exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3[data-v-a2f5676a] {\n  margin-bottom: 0 !important;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n.card-result[data-v-a2f5676a] {\n  background-color: #fcfcfc;\n  border-bottom: 1px solid #dac9be;\n  padding: 12px 8px;\n}\n.card-result[data-v-a2f5676a]:nth-child(odd) {\n  background-color: #f7f7f7;\n}\n.search-result-snippet[data-v-a2f5676a] em {\n  padding: 2px 4px;\n  background-color: #da831e4d;\n  border-radius: 10%;\n}\n.is-collapsed[data-v-a2f5676a] {\n  display: none;\n}\n.searchmore[data-v-a2f5676a] {\n  margin-top: 15px;\n}", ""]);

// exports
